import { Button, Card, EmptyState, Spinner, Table, type TableColumn } from "../../ds";
import type { Model } from "../../lib/api";

// Katalog der Router-Modelle inkl. der Aktionen je Zeile. `null` = lädt noch.

interface ModelTableProps {
  models: Model[] | null;
  onEdit: (model: Model) => void;
  onDelete: (model: Model) => void;
}

/** Auf Telefon-Breite bleiben Modellname und die Aktionen — Target und Profil
 *  stehen im Bearbeiten-Formular. */
function columns({ onEdit, onDelete }: Omit<ModelTableProps, "models">): TableColumn<Model>[] {
  return [
    { key: "name", header: "Modell", cell: (m) => m.name },
    { key: "target", header: "Target", mono: true, hideOnMobile: true, cell: (m) => m.target },
    { key: "profile", header: "Profil", mono: true, hideOnMobile: true, cell: (m) => m.profile },
    {
      key: "images",
      header: "Images",
      num: true,
      hideOnMobile: true,
      cell: (m) => m.firmwareCount,
    },
    {
      key: "notes",
      header: "Notiz",
      wrap: true,
      hideOnMobile: true,
      cell: (m) => m.notes || "—",
    },
    {
      key: "actions",
      header: "",
      align: "right",
      className: "actions",
      cell: (m) => (
        <div className="flex justify-end gap-2">
          <Button size="sm" variant="ghost" iconName="edit" onClick={() => onEdit(m)}>
            Bearbeiten
          </Button>
          <Button size="sm" variant="danger-outline" iconName="trash" onClick={() => onDelete(m)}>
            Löschen
          </Button>
        </div>
      ),
    },
  ];
}

export function ModelTable({ models, onEdit, onDelete }: ModelTableProps) {
  return (
    <Card
      title="Router-Modelle"
      subtitle="Target und Profil sind der Maßstab beim Image-Upload."
      bodyPadding={false}
    >
      {models === null ? (
        <div className="flex justify-center p-10">
          <Spinner />
        </div>
      ) : models.length === 0 ? (
        <EmptyState
          iconName="module"
          title="Keine Modelle"
          description="Ein Modell anlegen, damit hochgeladene Images dagegen geprüft werden können."
        />
      ) : (
        <Table columns={columns({ onEdit, onDelete })} rows={models} rowKey={(m) => m.id} />
      )}
    </Card>
  );
}
